const INITIAL_STATE = {
/*   pontoEmbarqueEndereco: {}, */
  pontoEmbarqueGrupoList: {
    data: []
  },
  pontoGurpoPesquisa:[],
  pontoEmbarqueGrupo: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'EMBARQUEGRUPO_FETCH':
        return { ...state, pontoEmbarqueGrupoList: action.payload }
        case 'EMBARQUEGRUPO_PESQUISA':
        return { ...state, pontoGurpoPesquisa: action.payload }
      case 'EMBARQUEGRUPO_SET':
        return { ...state, pontoEmbarqueGrupo: action.payload }
      /*   case 'EMBARQUEGRUPO_END':
        return { ...state, pontoEmbarqueEndereco: action.payload } */
      default:
        return state
    }
  }